import React from "react";
import Paper from "../components/ui-library/Paper/Paper";
import Img404 from "../assets/svg/404.svg";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div id="content" className="container-fluid">
      <div className="row">
        <Paper header={t("appText.notFound.title")}>
          <div
            className="h-100 w-100 d-flex flex-column align-items-center justify-content-around"
            style={{ color: "rgba(0,0,0,0.20)" }}
          >
            <img src={Img404} alt="Not Found" height={"300px"} />
            <div style={{ fontSize: "2.5rem" }}>
              {t("appText.notFound.message")}
            </div>
            <span
              className="text-center"
              dangerouslySetInnerHTML={{ __html: t("appText.notFound.info") }}
            />
          </div>
        </Paper>
      </div>
    </div>
  );
};

export default NotFound;
